module.exports = function(bootstrap) {
    bootstrap.directive('idCard', ['services', 'sessionData', function(services, sessionData) {
        return {
            restrict: 'A',
            replace: true,
            scope: {},
            template: require('directives/idCard.html'),
            link: function(scope, el, attrs){
                
                var opt = {},
                    currentMember = {},
                    deregisterWatch = scope.$watch(function() { return sessionData}, function(newVal){
                        if(newVal && newVal.memberInfo){

                            currentMember = services.rbsmbl.memberInfo().currentMember(sessionData.memberInfo);
                            opt = {
                                MProfileId: "",
                                UId: newVal.userName,
                                GNumber: newVal.groupNumber,
                                UNumber: newVal.memberInfo.umi,
                                CType: "MED",
                                EciId: currentMember && currentMember.ecId,
                                MTMID: "viewIdCard",
                                SID: "WEB",
                                logoId: newVal.memberInfo.brand,
                                covIndId: currentMember && currentMember.coveredIndividualId,
                                timestamp: Date.now()

                            };

                            scope.imgUrl = "/rbsmbl/x-services/idcard/getidcard?CType=" + opt.CType + "&EciId=" + opt.EciId +
                                "&GNumber=" + opt.GNumber + "&MProfileId=" + opt.MProfileId + "&MTMID=" + opt.MTMID +
                                "&SID=" + opt.SID + "&UId=" + opt.UId + "&UNumber=" + opt.UNumber + "&covIndId=" + opt.covIndId +
                                "&logoId=" + opt.logoId + "&timestamp=" + opt.timestamp;

                            deregisterWatch();
                        }
                    });
            }
        };
    }]);
};